import axiosInstance from 'api/axiosInstance';
export type EmailTemplate = {
    id: string;
    name: string;
    channel: string;
    notificationType: string;
    subType: string;
    subject: string;
    body: string;
    isActive: boolean;
    createdAt: string;
    modifiedAt: string;
};

export const emailRepository = {
    getEmails: async (): Promise<EmailTemplate[]> => {
        const { data } = await axiosInstance.get("/api/email-templates");
        return data;
    },
    getPaginatedEmails: async (
        pageNumber: number,
        pageSize: number
    ): Promise<EmailTemplate[]> => {
        const { data } = await axiosInstance.get("/api/email-templates", {
            params: { pageNumber, pageSize },
        });
        return data;
    },
    addEmail: async (emailData: Omit<EmailTemplate, 'id' | 'createdAt' | 'modifiedAt'>) => {
        const { data } = await axiosInstance.post("/api/email-templates", emailData);
        return data;
    },
    deleteEmail: async (id: string) => {
        return await axiosInstance.delete(`/api/email-templates/${id}`);
    },
    updateEmail: async (
        id: string,
        emailData: Partial<Omit<EmailTemplate, 'id' | 'createdAt' | 'modifiedAt'>>
    ) => {
        const { data } = await axiosInstance.put(`/api/email-templates/${id}`, emailData);
        return data;
    },

    exportEmails: async (): Promise<Blob> => {
  const response = await axiosInstance.get("/api/email-templates/export", {
    params: { format: "csv" },
    responseType: "blob",
  });
  return response.data;
},

};
